import React, { createContext } from "react";
import API_ROUTES from "./apiRoutes";

export const ApiConfigContext = createContext();

export const ApiConfigProvider = ({ children }) => {
  return (
    <ApiConfigContext.Provider value={{ routes: API_ROUTES }}>
      {children}
    </ApiConfigContext.Provider>
  );
};
